var map = {
	"./avatars/akash.png": 550,
	"./avatars/almas.png": 694,
	"./avatars/ferdous.png": 614,
	"./avatars/riyadh.png": 901,
	"./avatars/sadh.png": 529,
	"./avatars/salahuddin.png": 997,
	"./avatars/sumit.png": 908,
	"./logo.svg": 574,
	"./svg/delete.svg": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;